import React from 'react';
import {
  G,
  Path,
  Rect,
} from '@react-pdf/renderer';
import tinycolor from "tinycolor2";


export default function PDFBackground(props) {
  let viewBoxX = props.court.full ? 10 * -1 : (props.court.width / 2 + 10) * -1;
  let viewBoxY = props.court.full ? (props.court.width / 2 + 10) * -1 : 10 * -1;
  let viewBoxWidth = props.court.full ? props.court.length + 2 * 10 : props.court.width + 2 * 10;
  let viewBoxHeight = props.court.full ? props.court.width + 2 * 10 : (props.court.length + 2 * 10) / 2;

  //extract opacity from backgroundColor using tinycolor
  let color = tinycolor(props.courtColor.backgroundColor);
  let alpha = color.getAlpha();
  let hex = color.toHexString();


  if (props)
    return (
      <G style={{transform:`matrix(${viewBoxWidth/5200},0,0,${viewBoxHeight/4000},${viewBoxX},${viewBoxY})`}}>
      <G style={{transform: props.court.full ? `rotate(90deg) translate(0,-5280px) scaleY(1.4) ` : undefined}}>

        <Rect width={5280} height={4000} x={0} y={0} fill={hex} fillOpacity={alpha}/>
        {props.courtColor.showTiles && (
          <G transform="matrix(1.3333333,0,0,-1.3333333,0,2640)">
            <G transform="matrix(0,-0.1,0.1,0,0,1980)">
              <Path
                d="m 0,19200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d19d47', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path14"
              />
              <Path
                d="M 20340.7,19200.1 H 30000 v 600 h -9659.3 z"
                style={{fill: '#c89742', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path16"
              />
              <Path
                d="m 0,18600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#c98a28', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path18"
              />
              <Path
                d="m 0,18600.1 h 9260.69 v 600 H 0 Z"
                style={{fill: '#c49245', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path20"
              />
              <Path
                d="m 0,18000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path22"
              />
              <Path
                d="m 0,17400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path24"
              />
              <Path
                d="M 16560.7,17400.1 H 30000 v 600 H 16560.7 Z"
                style={{fill: '#ca8c2f', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path26"
              />
              <Path
                d="m 0,16800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#daa549', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path28"
              />
              <Path
                d="m 11100,16800.1 h 13800 v 600 H 11100 Z"
                style={{fill: '#da9f3b', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path30"
              />
              <Path
                d="m 0,16200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d8a651', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path32"
              />
              <Path
                d="m 0,16200.1 h 7040.69 v 600 H 0 Z"
                style={{fill: '#d49d44', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path34"
              />
              <Path
                d="m 0,15600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cf8f31', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path36"
              />
              <Path
                d="m 0,15600.1 h 13260.7 v 600 H 0 Z"
                style={{fill: '#ca8c2f', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path38"
              />
              <Path
                d="m 0,15000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path40"
              />
              <Path
                d="m 11280.3,15000.1 h 12000 v 600 h -12000 z"
                style={{fill: '#c89240', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path42"
              />
              <Path
                d="m 0,14400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path44"
              />
              <Path
                d="m 7920.69,14400.1 h 9000.01 v 600 H 7920.69 Z"
                style={{fill: '#cc9844', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path46"
              />
              <Path
                d="m 0,13800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#ca8c2f', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path48"
              />
              <Path
                d="m 0,13200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d3a24e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path50"
              />
              <Path
                d="M 20840.7,13200.1 H 30000 v 600 h -9159.3 z"
                style={{fill: '#c78925', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path52"
              />
              <Path
                d="m 0,13200.1 h 8095.35 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path54"
              />
              <Path
                d="m 0,12600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#c88f39', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path56"
              />
              <Path
                d="m 0,12600.1 h 11690.7 v 600 H 0 Z"
                style={{fill: '#d3a24a', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path58"
              />
              <Path
                d="m 0,12000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#daa549', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path60"
              />
              <Path
                d="m 15900,12000.1 h 12000 v 600 H 15900 Z"
                style={{fill: '#c48930', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path62"
              />
              <Path
                d="m 0,11400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path64"
              />
              <Path
                d="m 10200,11400.1 h 12000 v 600 H 10200 Z"
                style={{fill: '#c89240', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path66"
              />
              <Path
                d="m 0,10800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d6a447', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path68"
              />
              <Path
                d="m 0,10800.1 h 2620.69 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path70"
              />
              <Path
                d="m 0,10200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#c88d32', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path72"
              />
              <Path
                d="M 22220.7,10200.1 H 30000 v 600 h -7779.3 z"
                style={{fill: '#c5832d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path74"
              />
              <Path
                d="m 0,9600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d19f48', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path76"
              />
              <Path
                d="m 0,9600.1 h 12500.7 v 600 H 0 Z"
                style={{fill: '#ce943d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path78"
              />
              <Path
                d="m 0,9000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#c48930', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path80"
              />
              <Path
                d="m 13700.7,9000.1 h 12000 v 600 h -12000 z"
                style={{fill: '#c48f3d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path82"
              />
              <Path
                d="m 0,8400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path84"
              />
              <Path
                d="m 0,8400.1 h 8120.69 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path86"
              />
              <Path
                d="m 0,7800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path88"
              />
              <Path
                d="M 25168.2,7800.1 H 30000 v 600 h -4831.8 z"
                style={{fill: '#c88f37', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path90"
              />
              <Path
                d="m 0,7200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#daa549', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path92"
              />
              <Path
                d="m 0,6600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d3a24a', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path94"
              />
              <Path
                d="m 8100,6600.1 h 10200 v 600 H 8100 Z"
                style={{fill: '#cf9a3f', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path96"
              />
              <Path
                d="m 0,6000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d8a651', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path98"
              />
              <Path
                d="M 21290.7,6000.1 H 30000 v 600 h -8709.3 z"
                style={{fill: '#d49d44', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path100"
              />
              <Path
                d="m 0,5400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d7a246', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path102"
              />
              <Path
                d="m 0,5400.1 h 13140.7 v 600 H 0 Z"
                style={{fill: '#c88d32', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path104"
              />
              <Path
                d="m 0,4800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path106"
              />
              <Path
                d="M 24770.7,4800.1 H 30000 v 600 h -5229.3 z"
                style={{fill: '#ce9742', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path108"
              />
              <Path
                d="m 0,4200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path110"
              />
              <Path
                d="m 0,3600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d19740', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path112"
              />
              <Path
                d="m 0,3600.1 h 13260.7 v 600 H 0 Z"
                style={{fill: '#ca913c', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path114"
              />
              <Path
                d="m 0,3000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d8a651', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path116"
              />
              <Path
                d="M 21850.3,3000.1 H 30000 v 600 h -8149.7 z"
                style={{fill: '#c78925', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path118"
              />
              <Path
                d="m 0,2400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d3a24a', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path120"
              />
              <Path
                d="M 13700.7,2400.1 H 30000 v 600 H 13700.7 Z"
                style={{fill: '#cb8d3d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path122"
              />
              <Path
                d="m 0,1800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path124"
              />
              <Path
                d="m 10500,1800.1 h 9000 v 600 h -9000 z"
                style={{fill: '#ce9844', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path126"
              />
              <Path
                d="m 0,1200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d6a447', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path128"
              />
              <Path
                d="m 0,1200.1 h 6210.35 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path130"
              />
              <Path
                d="m 0,600.102 h 30000 v 600 H 0 Z"
                style={{fill: '#c48930', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path132"
              />
              <Path
                d="M 25168.2,600.102 H 30000 v 600 h -4831.8 z"
                style={{fill: '#c37e28', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path134"
              />
              <Path
                d="M 0,0.101563 H 30000 V 600 H 0 Z"
                style={{fill: '#ce943d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path136"
              />
              <Path
                d="M 0,0.101563 H 12420.7 V 600 H 0 Z"
                style={{fill: '#d19d47', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path138"
              />
            </G>
            <G id="g12-7" transform="matrix(0,-0.1,0.1,0,1979.9899,1980)">
              <Path
                d="m 0,19200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d19d47', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path14-0"
              />
              <Path
                d="M 20340.7,19200.1 H 30000 v 600 h -9659.3 z"
                style={{fill: '#c89742', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path16-0"
              />
              <Path
                d="m 0,18600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#c98a28', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path18-1"
              />
              <Path
                d="m 0,18600.1 h 9260.69 v 600 H 0 Z"
                style={{fill: '#c49245', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path20-0"
              />
              <Path
                d="m 0,18000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path22-3"
              />
              <Path
                d="m 0,17400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path24-0"
              />
              <Path
                d="M 16560.7,17400.1 H 30000 v 600 H 16560.7 Z"
                style={{fill: '#ca8c2f', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path26-0"
              />
              <Path
                d="m 0,16800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#daa549', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path28-3"
              />
              <Path
                d="m 11100,16800.1 h 13800 v 600 H 11100 Z"
                style={{fill: '#da9f3b', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path30-8"
              />
              <Path
                d="m 0,16200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d8a651', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path32-3"
              />
              <Path
                d="m 0,16200.1 h 7040.69 v 600 H 0 Z"
                style={{fill: '#d49d44', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path34-6"
              />
              <Path
                d="m 0,15600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cf8f31', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path36-0"
              />
              <Path
                d="m 0,15600.1 h 13260.7 v 600 H 0 Z"
                style={{fill: '#ca8c2f', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path38-4"
              />
              <Path
                d="m 0,15000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path40-0"
              />
              <Path
                d="m 11280.3,15000.1 h 12000 v 600 h -12000 z"
                style={{fill: '#c89240', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path42-9"
              />
              <Path
                d="m 0,14400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path44-2"
              />
              <Path
                d="m 7920.69,14400.1 h 9000.01 v 600 H 7920.69 Z"
                style={{fill: '#cc9844', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path46-4"
              />
              <Path
                d="m 0,13800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#ca8c2f', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path48-9"
              />
              <Path
                d="m 0,13200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d3a24e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path50-2"
              />
              <Path
                d="M 20840.7,13200.1 H 30000 v 600 h -9159.3 z"
                style={{fill: '#c78925', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path52-9"
              />
              <Path
                d="m 0,13200.1 h 8095.35 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path54-1"
              />
              <Path
                d="m 0,12600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#c88f39', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path56-0"
              />
              <Path
                d="m 0,12600.1 h 11690.7 v 600 H 0 Z"
                style={{fill: '#d3a24a', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path58-9"
              />
              <Path
                d="m 0,12000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#daa549', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path60-3"
              />
              <Path
                d="m 15900,12000.1 h 12000 v 600 H 15900 Z"
                style={{fill: '#c48930', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path62-0"
              />
              <Path
                d="m 0,11400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path64-0"
              />
              <Path
                d="m 10200,11400.1 h 12000 v 600 H 10200 Z"
                style={{fill: '#c89240', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path66-3"
              />
              <Path
                d="m 0,10800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d6a447', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path68-0"
              />
              <Path
                d="m 0,10800.1 h 2620.69 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path70-1"
              />
              <Path
                d="m 0,10200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#c88d32', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path72-9"
              />
              <Path
                d="M 22220.7,10200.1 H 30000 v 600 h -7779.3 z"
                style={{fill: '#c5832d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path74-8"
              />
              <Path
                d="m 0,9600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d19f48', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path76-6"
              />
              <Path
                d="m 0,9600.1 h 12500.7 v 600 H 0 Z"
                style={{fill: '#ce943d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path78-9"
              />
              <Path
                d="m 0,9000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#c48930', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path80-0"
              />
              <Path
                d="m 13700.7,9000.1 h 12000 v 600 h -12000 z"
                style={{fill: '#c48f3d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path82-1"
              />
              <Path
                d="m 0,8400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path84-6"
              />
              <Path
                d="m 0,8400.1 h 8120.69 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path86-4"
              />
              <Path
                d="m 0,7800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path88-4"
              />
              <Path
                d="M 25168.2,7800.1 H 30000 v 600 h -4831.8 z"
                style={{fill: '#c88f37', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path90-8"
              />
              <Path
                d="m 0,7200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#daa549', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path92-6"
              />
              <Path
                d="m 0,6600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d3a24a', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path94-1"
              />
              <Path
                d="m 8100,6600.1 h 10200 v 600 H 8100 Z"
                style={{fill: '#cf9a3f', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path96-4"
              />
              <Path
                d="m 0,6000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d8a651', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path98-0"
              />
              <Path
                d="M 21290.7,6000.1 H 30000 v 600 h -8709.3 z"
                style={{fill: '#d49d44', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path100-8"
              />
              <Path
                d="m 0,5400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d7a246', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path102-1"
              />
              <Path
                d="m 0,5400.1 h 13140.7 v 600 H 0 Z"
                style={{fill: '#c88d32', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path104-0"
              />
              <Path
                d="m 0,4800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path106-3"
              />
              <Path
                d="M 24770.7,4800.1 H 30000 v 600 h -5229.3 z"
                style={{fill: '#ce9742', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path108-1"
              />
              <Path
                d="m 0,4200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path110-1"
              />
              <Path
                d="m 0,3600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d19740', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path112-5"
              />
              <Path
                d="m 0,3600.1 h 13260.7 v 600 H 0 Z"
                style={{fill: '#ca913c', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path114-0"
              />
              <Path
                d="m 0,3000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d8a651', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path116-8"
              />
              <Path
                d="M 21850.3,3000.1 H 30000 v 600 h -8149.7 z"
                style={{fill: '#c78925', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path118-4"
              />
              <Path
                d="m 0,2400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d3a24a', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path120-9"
              />
              <Path
                d="M 13700.7,2400.1 H 30000 v 600 H 13700.7 Z"
                style={{fill: '#cb8d3d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path122-3"
              />
              <Path
                d="m 0,1800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path124-0"
              />
              <Path
                d="m 10500,1800.1 h 9000 v 600 h -9000 z"
                style={{fill: '#ce9844', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path126-5"
              />
              <Path
                d="m 0,1200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d6a447', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path128-2"
              />
              <Path
                d="m 0,1200.1 h 6210.35 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path130-3"
              />
              <Path
                d="m 0,600.102 h 30000 v 600 H 0 Z"
                style={{fill: '#c48930', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path132-8"
              />
              <Path
                d="M 25168.2,600.102 H 30000 v 600 h -4831.8 z"
                style={{fill: '#c37e28', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path134-7"
              />
              <Path
                d="M 0,0.101563 H 30000 V 600 H 0 Z"
                style={{fill: '#ce943d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path136-8"
              />
              <Path
                d="M 0,0.101563 H 12420.7 V 600 H 0 Z"
                style={{fill: '#d19d47', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path138-0"
              />
            </G>
            <Rect
            style={{fill: 'rgb(240,225,205)', fillOpacity: '0.6'}}
          //   style={{fill: '#fff', fillOpacity: '0.45'}}

              id="rect61026"
              width={3960}
              height={3100}
              x="-14.831265"
              y="-1991.865"
              transform="scale(1,-1)"
            />
          </G>
        )}
      </G>
      </G>
    );
}
